import { useEffect, useRef, useState } from 'react';

// Session storage keeps drafts through navigation/reloads without retaining them
// after this browser tab is closed. Each account has a separate namespace.
export default function useConversationDraft(conversationKey, accountKey) {
  const storageKey = `waManualDrafts:${accountKey}`;
  const drafts = useRef(null);
  const currentKey = useRef(conversationKey);
  const currentText = useRef('');
  const [text, setText] = useState('');
  currentKey.current = conversationKey;
  if (drafts.current === null) {
    try { drafts.current = JSON.parse(sessionStorage.getItem(storageKey) || '{}'); }
    catch (_err) { drafts.current = {}; }
    if (!drafts.current || typeof drafts.current !== 'object' || Array.isArray(drafts.current)) drafts.current = {};
  }
  useEffect(() => {
    const restored = typeof drafts.current[conversationKey] === 'string' ? drafts.current[conversationKey] : '';
    currentText.current = restored;
    setText(restored);
  }, [conversationKey]);
  const update = (value) => {
    const next = typeof value === 'function' ? value(currentText.current) : value;
    if (conversationKey) {
      if (next) drafts.current[conversationKey] = next;
      else delete drafts.current[conversationKey];
      try { sessionStorage.setItem(storageKey, JSON.stringify(drafts.current)); }
      catch (_err) { /* El borrador sigue disponible mientras no se salga de la pantalla. */ }
    }
    // A send may finish after switching chats: clear only the originating draft.
    if (currentKey.current === conversationKey) { currentText.current = next; setText(next); }
  };
  return [text, update];
}
